import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL!
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY!

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

export type Database = {
  public: {
    Tables: {
      user_profiles: {
        Row: {
          id: string
          full_name: string | null
          company: string | null
          phone_number: string | null
          created_at: string | null
          last_login: string | null
          is_active: boolean | null
        }
        Insert: {
          id: string
          full_name?: string | null
          company?: string | null
          phone_number?: string | null
          created_at?: string | null
          last_login?: string | null
          is_active?: boolean | null
        }
        Update: {
          id?: string
          full_name?: string | null
          company?: string | null
          phone_number?: string | null
          created_at?: string | null
          last_login?: string | null
          is_active?: boolean | null
        }
      }
      applications: {
        Row: {
          id: string
          name: string
          url: string
          description: string
          icon_url: string
          created_at: string
          updated_at: string
        }
        Insert: {
          id?: string
          name: string
          url: string
          description: string
          icon_url: string
          created_at?: string
          updated_at?: string
        }
        Update: {
          id?: string
          name?: string
          url?: string
          description?: string
          icon_url?: string
          created_at?: string
          updated_at?: string
        }
      }
      user_app_access: {
        Row: {
          id: string
          user_id: string
          app_id: string
          created_at: string
          updated_at: string
        }
        Insert: {
          id?: string
          user_id: string
          app_id: string
          created_at?: string
          updated_at?: string
        }
        Update: {
          id?: string
          user_id?: string
          app_id?: string
          created_at?: string
          updated_at?: string
        }
      }
    }
  }
}